
import { tr } from "@/lib/i18n";export const ZONE_COLORS = { F: "#b45309", G: "#f59e0b", H: "#0F52BA", I: "#38bdf8" };
export const ZONE_LABEL = { F: tr("F · angolo"), G: tr("G · bordo"), H: tr("H · intermedia"), I: tr("I · interna") };

export const newField = (n) => ({
  id: `f${Date.now().toString(36)}`, name: tr("Campo {0}", [n]), polygon: [], pitch: 20, azimuth: 0, obstacles: [], removed: [],
});
